import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["mask"]
const _hoisted_5 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("g", null, [
    _cache[0] || (_cache[0] = _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.7778 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 3 21 2 19.7778 2Z"
    }, null, -1)),
    _createElementVNode("circle", {
      cx: "12",
      cy: "9",
      r: "3",
      fill: _ctx.iconColor
    }, null, 8, _hoisted_1),
    _createElementVNode("mask", {
      id: _ctx.maskId,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "4",
      y: "14",
      width: "16",
      height: "5"
    }, [
      _createElementVNode("rect", {
        x: "4",
        y: "14",
        width: "16",
        height: "5",
        fill: _ctx.iconColor
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("g", {
      mask: 'url(#' + _ctx.maskId + ')'
    }, [
      _createElementVNode("ellipse", {
        cx: "12",
        cy: "19",
        rx: "6",
        ry: "5",
        fill: _ctx.iconColor
      }, null, 8, _hoisted_5)
    ], 8, _hoisted_4)
  ]))
}